"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Select = require("../../components/Select");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var getHighlightColor = function getHighlightColor(_ref) {
  var props = _ref.props,
    theme = _ref.theme;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme.colors.active;
  return props.errorText ? theme.colors.alert : color;
};
var getColor = function getColor(_ref2) {
  var state = _ref2.state,
    theme = _ref2.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast050;
  }
  if (state.isSelected) {
    return theme.colors.baseContrast090;
  }
  return theme.colors.baseContrast085;
};
var getBorderColor = function getBorderColor(_ref3) {
  var props = _ref3.props,
    state = _ref3.state,
    theme = _ref3.theme;
  if (props.errorText) {
    return theme.colors.alert;
  }
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  if (props.button === "flat") {
    return "transparent";
  }
  if (state.menuIsOpen || state.isFocused) {
    return getHighlightColor({
      props: props,
      theme: theme
    });
  }
  return theme.colors.baseContrast040;
};
var getSingleValueStyles = function getSingleValueStyles(_ref4) {
  var props = _ref4.props,
    state = _ref4.state,
    theme = _ref4.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast050;
  }
  if (props.button !== null) {
    return theme.colors.baseContrast100;
  }
  return theme.colors.baseContrast085;
};
var Select = {
  styles: function styles(theme) {
    return {
      labelText: {
        marginInlineStart: 2,
        display: "block",
        marginBottom: 2,
        color: theme.colors.baseContrast085,
        textTransform: "uppercase",
        fontSize: _Select.selectVars.get("labelFontSize", "".concat(theme.typography.fontSize, "px")),
        fontWeight: 600
      },
      lightBackground: {
        borderRadius: 7
      },
      hint: {
        marginInlineStart: theme.spacing.base / 2,
        textTransform: "initial",
        color: theme.colors.baseContrast085
      },
      description: {
        textTransform: "initial",
        color: theme.colors.baseContrast085
      }
    };
  },
  select: {
    placeholder: function placeholder(_ref5) {
      var theme = _ref5.theme;
      return {
        color: theme.colors.baseContrast050
      };
    },
    control: function control(_ref6) {
      var props = _ref6.props,
        state = _ref6.state,
        theme = _ref6.theme;
      return {
        paddingInlineStart: theme.spacing.base * 1.5 - 1,
        borderWidth: 1,
        borderRadius: 7,
        background: state.isDisabled ? theme.colors.baseContrast015 : theme.colors.pageBackground,
        // TODO: figure out split into separate objects for `error`, `disabled`, etc states
        borderColor: getBorderColor({
          state: state,
          props: props,
          theme: theme
        }),
        boxShadow: state.menuIsOpen || state.isFocused ? "0 0 6px 0 ".concat(getHighlightColor({
          props: props,
          theme: theme
        })) : "unset",
        "&:hover": {
          borderColor: getHighlightColor({
            props: props,
            theme: theme
          }),
          background: theme.colors.pageBackground
        }
      };
    },
    dropdownIndicator: function dropdownIndicator(_ref7) {
      var theme = _ref7.theme,
        state = _ref7.state;
      return {
        paddingInlineEnd: theme.spacing.base,
        "& svg": {
          fill: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseContrast085
        }
      };
    },
    indicatorSeparator: function indicatorSeparator(_ref8) {
      var theme = _ref8.theme,
        state = _ref8.state;
      return {
        background: state.isDisabled ? theme.colors.baseContrast030 : theme.colors.baseContrast040,
        // separator bar color
        width: 1
      };
    },
    multiValue: function multiValue(_ref9) {
      var props = _ref9.props,
        theme = _ref9.theme,
        state = _ref9.state;
      return {
        background: state.isDisabled ? theme.colors.baseContrast030 : getHighlightColor({
          props: props,
          theme: theme
        }, theme.colors.primary),
        borderRadius: 4
      };
    },
    multiValueLabel: function multiValueLabel(_ref0) {
      var theme = _ref0.theme;
      return {
        color: theme.colors.themeBase,
        marginLeft: 4,
        marginRight: 4,
        "&:hover, &:focus-visible": {
          color: theme.colors.themeBase
        }
      };
    },
    multiValueRemove: function multiValueRemove(_ref1) {
      var theme = _ref1.theme;
      return {
        background: "none",
        paddingLeft: 4,
        paddingRight: 4,
        color: theme.colors.themeBase,
        "&:hover, &:focus-visible": {
          color: theme.colors.themeBase,
          background: "none"
        }
      };
    },
    menu: function menu(_ref10) {
      var theme = _ref10.theme;
      return {
        color: theme.colors.baseContrast085,
        borderRadius: 4,
        background: theme.colors.pageBackground,
        borderColor: theme.colors.baseContrast010
      };
    },
    option: function option(_ref11) {
      var theme = _ref11.theme,
        state = _ref11.state;
      return {
        paddingInlineStart: theme.spacing.base * 2,
        background: state.isSelected ? theme.colors.baseContrast015 : theme.colors.baseContrast010,
        color: getColor({
          state: state,
          theme: theme
        }),
        "&:hover, &:focus-visible": {
          borderColor: theme.colors.active,
          background: theme.colors.baseContrast020
        }
      };
    },
    singleValue: function singleValue(_ref12) {
      var theme = _ref12.theme,
        state = _ref12.state,
        props = _ref12.props;
      return {
        color: getSingleValueStyles({
          state: state,
          props: props,
          theme: theme
        })
      };
    }
  }
};
var _default = exports.default = Select;